$(function () {
	$('[data-individual-size-modal]').each(function () {
		const $modal = $(this);
		const $form = $modal.find('[data-individual-size-form]');
		const $fields = $form.find('[name="opening_width"], [name="opening_height"]');
		const $quote = $modal.find('[data-individual-quote]');
		const $loading = $modal.find('[data-individual-quote-loading]');
		const $error = $modal.find('[data-individual-quote-error]');
		const $result = $modal.find('[data-individual-quote-result]');
		let timer = null;
		let pending = null;
		let revision = 0;

		const show = ($element = null) => {
			[$loading, $error, $result].forEach($item => $item.prop('hidden', true));
			$quote.prop('hidden', !$element);
			if ($element) $element.prop('hidden', false);
		};
		const values = () => {
			const width = $form.find('[name="opening_width"]')[0];
			const height = $form.find('[name="opening_height"]')[0];
			const errors = [];
			[[width, 'Ширина'], [height, 'Высота']].forEach(([field, label]) => {
				if (field.validity.badInput) {
					errors.push(`${label}: введите размер в миллиметрах.`);
				} else if (field.value && (field.validity.rangeUnderflow || field.validity.rangeOverflow)) {
					errors.push(`${label}: укажите размер от ${field.min} до ${field.max} мм.`);
				} else if (field.value && field.validity.stepMismatch) {
					errors.push(`${label}: допустимый шаг ${field.step} мм.`);
				}
			});
			if (errors.length) return {error: errors.join(' ')};
			if (!width.value || !height.value) return {};
			return {data: {
				opening_mode: 1,
				serie_id: Number($form.find('[name="serie_id"]').val()),
				opening_width: Number(width.value),
				opening_height: Number(height.value)
			}};
		};
		const calculate = () => {
			const input = values();
			if (pending) { pending.abort(); pending = null; }
			const currentRevision = ++revision;
			if (input.error) { $error.text(input.error); show($error); return; }
			if (!input.data) { show(); return; }
			show($loading);
			pending = $.getJSON($modal.data('quote-url'), input.data).done(function (response) {
				if (currentRevision !== revision) return;
				$result.html(response.summary_html);
				show($result);
			}).fail(function (xhr, status) {
				if (status === 'abort' || currentRevision !== revision) return;
				const errors = xhr.responseJSON && xhr.responseJSON.errors;
				$error.text(errors ? Object.values(errors).flat().join(' ') : 'Не удалось узнать стоимость. Попробуйте ещё раз.');
				show($error);
			}).always(function () {
				if (currentRevision === revision) pending = null;
			});
		};
		const schedule = () => {
			clearTimeout(timer);
			if (!values().data) { calculate(); return; }
			timer = setTimeout(calculate, 350);
		};

		$fields.on('input change', schedule);
		$modal.on('show.bs.modal', calculate).on('hidden.bs.modal', function () {
			clearTimeout(timer);
			revision++;
			if (pending) { pending.abort(); pending = null; }
		});
		$form.on('submit-success', function () {
			$form.find('[name^="user_"]').val('');
		});
	});
});
